/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type InvestmentStatusEnum = 'A' | 'P' | 'R' | 'U' | 'D' | '11184809';

export const InvestmentStatusEnum = {
  A: 'A' as InvestmentStatusEnum,
  P: 'P' as InvestmentStatusEnum,
  R: 'R' as InvestmentStatusEnum,
  U: 'U' as InvestmentStatusEnum,
  D: 'D' as InvestmentStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as InvestmentStatusEnum
};
